/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  description: {
    marginBottom: '16px',
  },
  altCtaTextButton: {
    border: 'none',
    padding: '0rem',
    color: theme.palette.primary.OfferSelected,
    textDecoration: 'underline',
  },
});

export default styles;
